import React, { useEffect, useState } from 'react';
import { FiX, FiCheckCircle, FiAlertCircle, FiAlertTriangle, FiInfo } from 'react-icons/fi';
import { Toast as ToastType } from '../../shared/types/toast';
import './toast.css';

interface ToastProps {
  toast: ToastType;
  onRemove: (id: string) => void;
}

const Toast: React.FC<ToastProps> = ({ toast, onRemove }) => {
  const [isExiting, setIsExiting] = useState(false);
  const [progress, setProgress] = useState(100);

  const getIcon = () => {
    switch (toast.type) {
      case 'success':
        return <FiCheckCircle size={20} />;
      case 'error':
        return <FiAlertCircle size={20} />;
      case 'warning':
        return <FiAlertTriangle size={20} />;
      case 'info':
      default:
        return <FiInfo size={20} />;
    }
  };

  const handleClose = () => {
    setIsExiting(true);
    setTimeout(() => onRemove(toast.id), 300);
  };

  useEffect(() => {
  const duration = toast.duration || 5000;
  const interval = 50;
  const step = (interval / duration) * 100;

  const handleCloseLocal = () => {
    setIsExiting(true);
    setTimeout(() => onRemove(toast.id), 300);
  };

  const timer = setInterval(() => {
    setProgress(prev => {
      if (prev <= 0) {
        handleCloseLocal();
        return 0;
      }
      return prev - step;
    });
  }, interval);

  return () => clearInterval(timer);
}, [toast.duration, toast.id, onRemove]);

  return (
    <div className={`arqite-toast arqite-toast--${toast.type} ${isExiting ? 'arqite-toast--exiting' : ''}`}>
      <div className="arqite-toast__content">
        <div className="arqite-toast__icon">
          {getIcon()}
        </div>
        
        <div className="arqite-toast__text">
          <h4 className="arqite-toast__title">{toast.title}</h4>
          {toast.message && (
            <p className="arqite-toast__message">{toast.message}</p>
          )}
        </div>

        <div className="arqite-toast__actions">
          {toast.action && (
            <button
              className="arqite-toast__action-btn"
              onClick={toast.action.onClick}
            >
              {toast.action.label}
            </button>
          )}
          <button
            className="arqite-toast__close-btn"
            onClick={handleClose}
            aria-label="Close notification"
          >
            <FiX size={16} />
          </button>
        </div>
      </div>
      
      <div className="arqite-toast__progress">
        <div 
          className="arqite-toast__progress-bar"
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
};

export default Toast;
